import React from 'react';
import { Link, Switch } from 'react-router-dom';
import AuthorizedRoute from '../../_helpers/authorized.route';

import ListGroups from './ListGroups/';
import CreateGroup from './CreateGroup/';
import GroupReservations from './GroupReservations/';

import CreateSchedule from './CreateSchedule/';
import ListSchedule from './ListSchedule/';
import ListTimeSlots from './ListTimeSlots';

import Vaccinations from './Vaccinations';
import VaccinationEdit from './Vaccinations/VaccinationEdit';
import VaccinationDetails from './Vaccinations/VaccinationDetails';

import AllReservations from './AllReserations';
import Settings from '../../_layouts/Settings/';

export default function Vaccine({ history }) {
  return <div className="container-fluid">
    <div className="row">
      <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block sidebar pt-5">
        <div className="sidebar-sticky pt-5">
          <ul className="nav flex-column">
            <li className="nav-item p-2 border-bottom">
              <Link to="/vaccine/cair" className={`nav-link ${history.location.pathname.indexOf('/vaccine/cair') === 0 ? 'active' : ''}`}>
                <i className="fa fa-medkit fa-fw" aria-hidden="true"></i>&nbsp;CAIR
              </Link>
            </li>
            <li className="nav-item p-2 border-bottom">
              <Link to="/vaccine/reservations" className={`nav-link ${history.location.pathname.indexOf('/vaccine/reservations') === 0 ? 'active' : ''}`}>
                <i className="fa fa-user fa-fw" aria-hidden="true"></i>&nbsp;All Reservations
              </Link>
            </li>
            <li className="nav-item p-2 border-bottom">
              <Link to="/vaccine/schedule" className={`nav-link ${history.location.pathname.indexOf('/vaccine/schedule') === 0 ? 'active' : ''}`}>
                <i className="fa fa-calendar fa-fw" aria-hidden="true"></i>&nbsp;Mass Schedule
              </Link>
            </li>
            <li className="nav-item p-2 border-bottom">
              <Link to="/vaccine/groups" className={`nav-link ${history.location.pathname.indexOf('/vaccine/groups') === 0 ? 'active' : ''}`}>
                <i className="fa fa-users fa-fw" aria-hidden="true"></i>&nbsp;Groups
              </Link>
            </li>
          </ul>
        </div>
      </nav>

      <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-md-4">
        <Switch>
          <AuthorizedRoute path="/vaccine/cair/view/:id" layout={Settings} component={VaccinationDetails} />
          <AuthorizedRoute path="/vaccine/cair/edit/:id" layout={Settings} component={VaccinationEdit} />
          <AuthorizedRoute path="/vaccine/cair" layout={Settings} component={Vaccinations} />

          <AuthorizedRoute path="/vaccine/reservations" layout={Settings} component={AllReservations} />

          <AuthorizedRoute path="/vaccine/schedule/:scheduleId/timeslots" layout={Settings} component={ListTimeSlots} />
          <AuthorizedRoute path="/vaccine/schedule/create" layout={Settings} component={CreateSchedule} />
          <AuthorizedRoute path="/vaccine/schedule" layout={Settings} component={ListSchedule} />

          <AuthorizedRoute path="/vaccine/groups/:groupId/reservations" layout={Settings} component={GroupReservations} />
          <AuthorizedRoute path="/vaccine/groups/create" layout={Settings} component={CreateGroup} />
          <AuthorizedRoute path="/vaccine/groups" layout={Settings} component={ListGroups} />
        </Switch>
      </main>
    </div>
  </div>
}